/* eslint-disable import/prefer-default-export */
import cacheData from "memory-cache";
import Env from "Consts/env";
import Axios from "./axios";

export const submitLike = async (params) => {

	try {

		const result = await Axios({
			method: "POST",
			url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/${process.env.NEXT_PUBLIC_API_SUBMIT_LIKE}`,
			data: params,
			headers: { ...Env.HEADERS },
		});
		return result;

	} catch (error) {

		throw new Error("Error Something");

	}

};

export const getComments = async (params) => {

	try {

		const result = await Axios({
			method: "GET",
			url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/${process.env.NEXT_PUBLIC_API_GET_COMMENTS}`,
			headers: { ...params, ...Env.HEADERS },
		});
		return result;

	} catch (error) {

		throw new Error("Error Something");

	}

};

export const submitComment = async (params) => {

	try {

		const result = await Axios({
			method: "POST",
			url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/${process.env.NEXT_PUBLIC_API_SUBMIT_COMMENT}`,
			data: params,
			headers: { ...Env.HEADERS },
		});
		return result;

	} catch (error) {

		throw new Error("Error Something");

	}

};

export const fetchWithCache = async (url, time, options) => {

	const value = cacheData.get(url);
	// clear cache
	// cacheData.clear()
	if (value) {

		return value;

	}
	const hours = typeof time !== "undefined" ? time : 1;
	const res = await fetch(url, options, { headers: { ...Env.HEADERS } });
	let data = null;
	if (res && typeof res !== "undefined" && typeof res.status !== "undefined" && res.status === 200) {

		cacheData.put(url, data, hours * 1000 * 60 * 60);
		data = await res.json();

	}
	return data;

};

export const submitFollow = async (params) => {

	try {

		const result = await Axios({
			method: "POST",
			url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/submitFollow`,
			data: params,
			headers: { ...Env.HEADERS },
		});
		return result;

	} catch (error) {

		throw new Error("Error Something");

	}

};

export const submitAddProduct = async (params) => {

	try {

		const url = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/submitAddProduct`;
		const method = "POST";
		const headers = {
			Authorization: params.Authorization,
			"CSRF-Token": params["CSRF-Token"],
			"api-token": params["api-token"],
			...Env.HEADERS,
		};
		const body = JSON.stringify(params.data);

		const result = await fetch(url, { method, headers, body });

		return await result.json();

	} catch (error) {

		throw new Error("Failed to submit add product");

	}

};

export const getNotification = async (params) => {

	try {

		const result = await Axios({
			method: params.method,
			url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/getNotification`,
			headers: {
				Authorization: params.Authorization,
			},
		});
		return result;

	} catch (error) {

		throw new Error("Error response");

	}

};

export const updateNotificationStatus = async (params) => {

	try {

		const result = await Axios({
			method: params.method,
			url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/updateNotificationStatus/`,
			headers: {
				Authorization: params.Authorization,
			},
			data: params.data,
		});
		return result;

	} catch (error) {

		throw new Error("Error response");

	}

};
